export default "/institutions/contabilizei.svg";